import img1After1200 from "@assets/1-tlc-associates-tree-service-trimming-pruning-after-1200_1775856400012.webp";
import img1After600 from "@assets/1-tlc-associates-tree-service-trimming-pruning-after-600_1775856400013.webp";
import img1Before1200 from "@assets/1-tlc-associates-tree-service-trimming-pruning-before-1200_1775856400010.webp";
import img1Before600 from "@assets/1-tlc-associates-tree-service-trimming-pruning-before-600_1775856400011.webp";

import img2After1200 from "@assets/2-tlc-associates-maintenance-hedge-trimming-shaping-after-1200.webp";
import img2After600 from "@assets/2-tlc-associates-maintenance-hedge-trimming-shaping-after-600_1775856524989.webp";
import img2Before1200 from "@assets/2-tlc-associates-maintenance-hedge-trimming-shaping-before-12_1775856299105.webp";
import img2Before600 from "@assets/2-tlc-associates-maintenance-hedge-trimming-shaping-before-60_1775856299104.webp";

import img3After1200 from "@assets/3-tlc-associates-backyard-hardscaping-stone-after-1200_1775857227503.webp";
import img3After600 from "@assets/3-tlc-associates-backyard-hardscaping-stone-after-600_1775857227502.webp";
import img3Before1200 from "@assets/3-tlc-associates-backyard-hardscaping-stone-before-1200_1775857227503.webp";
import img3Before600 from "@assets/3-tlc-associates-backyard-hardscaping-stone-before-600_1775857227503.webp";

import img4After1200 from "@assets/4-tlc-associates-after-1200_1775857227502.webp";
import img4After600 from "@assets/4-tlc-associates-after-600_1775857227501.webp";
import img4Before1200 from "@assets/4-tlc-associates-before-1200_1775857227500.webp";
import img4Before600 from "@assets/4-tlc-associates-before-600_1775857227499.webp";

import img5After1200 from "@assets/5-tlc-associates-landscaping-garden-bed-installation-1200_1775857343657.webp";
import img5After600 from "@assets/5-tlc-associates-landscaping-garden-bed-installation-after-60_1775857343657.webp";
import img5Before1200 from "@assets/5-tlc-associates-residential-landscaping-before_1775857343655.webp";
import img5Before600 from "@assets/5-tlc-associates-residential-landscape-maintenance-service-60_1775857343656.webp";

import img6After1200 from "@assets/6-tlc-associates-residential-shrub-maintenance-service-1200_1775857617412.webp";
import img6After600 from "@assets/6-tlc-associates-residential-shrub-maintenance-service-600_1775857617413.webp";
import img6Before1200 from "@assets/6-tlc-associates-residential-shrub-maintenance-service-before-1200.webp";
import img6Before600 from "@assets/6-tlc-associates-residential-shrub-maintenance-service-before_1775857617414.webp";

import img7After1200 from "@assets/7-tlc-associates-overgrown-yard-clearance-service-after-1200.webp";
import img7After600 from "@assets/7-tlc-associates-overgrown-yard-clearance-service-after-600_1775861463531.webp";
import img7Before1200 from "@assets/7-tlc-associates-overgrown-yard-clearance-service-before-1200_1775861463529.webp";
import img7BeforeAlt from "@assets/7-tlc-associates-overgrown-yard-clearance-service-before-_1775861463533.webp";
import img7Before600 from "@assets/7-tlc-associates-overgrown-yard-clearance-service-before-600_1775861463526.webp";

import img8After1200 from "@assets/8-tlc-associates-residential-landscaping-front-yard-after-120_1775861662326.webp";
import img8After600 from "@assets/8-tlc-associates-residential-landscaping-front-yard-after-600_1775861662324.webp";
import img8Before1200 from "@assets/8-tlc-associates-residential-landscaping-front-yard-before-12_1775861662331.webp";
import img8Before600 from "@assets/8-tlc-associates-residential-landscaping-front-yard-before-60_1775861662329.webp";

import img9After1200 from "@assets/9-tlc-associates-commercial-landscape-maintenance-service-120_1775860765533.webp";
import img9After600 from "@assets/9-tlc-associates-commercial-landscape-maintenance-service-600_1775860765536.webp";
import img9Before1200 from "@assets/9-tlc-associates-overgrown-yard-cleanup-service-1200_1775860765527.webp";
import img9Before600 from "@assets/9-tlc-associates-overgrown-yard-cleanup-service-600_1775860765530.webp";

import img10After1200 from "@assets/10-tlc-associates-residential-landscaping-yard-preparation-12_1780422021774.webp";
import img10After600 from "@assets/10-tlc-associates-residential-landscaping-yard-preparation-af_1780422021773.webp";
import img10Before1200 from "@assets/10-tlc-associates-residential-landscaping-yard-preparation-before-1200.webp";
import img10Before600 from "@assets/10-tlc-associates-residential-landscaping-yard-preparation-be_1775866510144.webp";

import img11After1200 from "@assets/11-tlc-associates-landscape-installation-after-1200_1775864027580.webp";
import img11After600 from "@assets/11-tlc-associates-landscape-installation-after-600_1775864027583.webp";
import img11Before1200 from "@assets/11-tlc-associates-landscape-installation-before-1200_1775864027585.webp";
import img11Before600 from "@assets/11-tlc-associates-landscape-installation-before-600_1775864027588.webp";

import img12After1200 from "@assets/12-tlc-associates-residential-landscaping-after-1200_1775866604597.webp";
import img12After600 from "@assets/12-tlc-associates-residential-landscaping-after-600_1775866604599.webp";
import img12Before1200 from "@assets/12-tlc-associates-overgrown-roadside-tlc-associates-residenti_1775866604601.webp";
import img12Before600 from "@assets/12-tlc-associates-overgrown-roadside-tlc-associates-residenti_1775866604603.webp";

import img13a from "@assets/13-tlc-associates-commercial-landscaping-maintenance-service__1775870050137.webp";
import img13b from "@assets/13-tlc-associates-commercial-landscaping-maintenance-service__1775870050140.webp";
import img13c from "@assets/13-tlc-associates-commercial-landscaping-maintenance-service__1775870050142.webp";
import img13d from "@assets/13-tlc-associates-commercial-landscaping-maintenance-service__1775870050145.webp";

import img14After1200 from "@assets/14-tlc-associates-tree-trimming-landscaping-service-after-120_1775867289831.webp";
import img14Before1200 from "@assets/14-tlc-associates-tree-trimming-landscaping-service-before-12_1775867289835.webp";
import img14Before600 from "@assets/14-tlc-associates-tree-trimming-landscaping-service-before-60_1775867289833.webp";
import img14Done1200 from "@assets/14-tlc-associates-landscaping-tree-installaton-done-1200_1775867289828.webp";

import img15After1200 from "@assets/15-tlc-associates-residential-landscaping-maintenance-drivewa_1775871778816.webp";
import img15After600 from "@assets/15-tlc-associates-residential-landscaping-maintenance-drivewa_1775871778819.webp";
import img15Before1200 from "@assets/15-tlc-associates-residential-landscaping-maintenance-driveway-before-1200.webp";
import img15Before600 from "@assets/15-tlc-associates-residential-landscaping-maintenance-drivewa_1775871778826.webp";

import img16Path1200 from "@assets/16-tlc-associates-wood-mulch-landscaping-pathway-1200_1775872022139.webp";
import img16Path600 from "@assets/16-tlc-associates-wood-mulch-landscaping-pathway-600_1775872022142.webp";
import img16Clear1200 from "@assets/16-tlc-associates-landscape-clearing-heavy-equipment-1200_1775872022145.webp";
import img16Clear600 from "@assets/16-tlc-associates-landscape-clearing-heavy-equipment-600_1775872022148.webp";

import img17After1200 from "@assets/17-tlc-associates-residential-landscaping-after-1200_1775872101150.webp";
import img17After600 from "@assets/17-tlc-associates-residential-landscaping-after-600_1775872101153.webp";
import img17Before1200 from "@assets/17-tlc-associates-residential-landscaping-before-1200_1775872101144.webp";
import img17Before600 from "@assets/17-tlc-associates-residential-landscaping-before-600_1775872101147.webp";

import img20Desktop from "@assets/tlc-associates-tree-ring-mulch-bed-planting-1200.webp";
import img18 from "@assets/tlca_1775908897023.webp";
import img19 from "@assets/tlcc_1775908897020.webp";
import img21 from "@assets/tlc-f_1775908942905.webp";
import serviceAreaHeroMobile from "@assets/tlc-f_1775908942905_600.webp";
import img22 from "@assets/tlc-g_1775908942907.webp";
import img23 from "@assets/tlc-i_1775908951725.webp";
import maintenanceHeroMobile from "@assets/tlc-i_1775908951725_600.webp";
import img24 from "@assets/tlc-j_1775908951725.webp";
import contactHeroMobile from "@assets/tlc-j_1775908951725_600.webp";
import img25 from "@assets/tlc-k_1775908951724.webp";
import img26 from "@assets/tlc-l_1775908951723.webp";

import img27After from "@assets/tlc-after-weeding-pruning-mulching_1775908987239.webp";
import img27Before from "@assets/tlc-before-weeding-pruning-mulching_1775908987237.webp";

import img28After from "@assets/tlc-comm-after-1-600x450.webp";
import img28Before from "@assets/tlc-comm-before-1-600x450.webp";

import img29After from "@assets/tlc-comm-after-2_1775908994316.webp";
import img29AfterSmall from "@assets/tlc-comm-after-2-600x450.webp";
import commercialHeroMobile from "@assets/tlc-comm-after-2-600x450_800.webp";
import img29Before from "@assets/tlc-comm-before-2_1775908994315.webp";
import img29BeforeSmall from "@assets/tlc-comm-before-2-600x450.webp";
import img32Before1200 from "@assets/tlc-associates-roadside-overgrowth-before-1200.webp";
import img32Before600 from "@assets/tlc-associates-roadside-overgrowth-before-600.webp";
import img32After1200 from "@assets/tlc-associates-groundcover-trimming-after-1200.webp";
import img32After600 from "@assets/tlc-associates-groundcover-trimming-after-600.webp";
import img33Before1200 from "@assets/tlc-associates-landscape-maintenance-before-1200_(1)_1783022068104.webp";
import img33Before600 from "@assets/tlc-associates-landscape-maintenance-before-600_(1)_1783022068103.webp";
import img33After1200 from "@assets/tlc-associates-brush-shrub-clearing-after-1200.webp";
import img33After600 from "@assets/tlc-associates-brush-shrub-clearing-after-600.webp";
import img34Before1200 from "@assets/tlc-associates-landscape-maintenance-1200_1783022951644.webp";
import img34Before600 from "@assets/tlc-associates-landscape-maintenance-600_1783022951643.webp";
import img34After1200 from "@assets/tlc-associates-landscape-maintenance-2-1200_1783022951642.webp";
import img34After600 from "@assets/tlc-associates-landscape-maintenance-2-600_1783022951641.webp";
import img35Before1200 from "@assets/tlc-associates-garden-planting-2487-1200.webp";
import img35Before600 from "@assets/tlc-associates-garden-planting-2487-600.webp";
import img35After1200 from "@assets/tlc-associates-garden-planting-2491-1200.webp";
import img35After600 from "@assets/tlc-associates-garden-planting-2491-600.webp";

import lmJob1Before1200 from "@assets/tlc-associates-lm-job1-before-1200x900.webp";
import lmJob1Before600 from "@assets/tlc-associates-lm-job1-before-600x450.webp";
import lmJob1After1200 from "@assets/tlc-associates-lm-job1-after-1200x900.webp";
import lmJob1After600 from "@assets/tlc-associates-lm-job1-after-600x450.webp";
import lmJob2Before1200 from "@assets/tlc-associates-lm-job2-before-1200x900.webp";
import lmJob2Before600 from "@assets/tlc-associates-lm-job2-before-600x450.webp";
import lmJob2After1200 from "@assets/tlc-associates-lm-job2-after-1200x900.webp";
import lmJob2After600 from "@assets/tlc-associates-lm-job2-after-600x450.webp";

import renovJob2FranklinBefore from "@assets/tlc-associates-landscape-renovation-job2-before-franklin-4x3-_1787270257227.webp";
import renovJob2FranklinAfter from "@assets/tlc-associates-landscape-renovation-job2-after-franklin-4x3-1_1787270257227.webp";
import renovJob3Before from "@assets/tlc-associates-landscape-renovation-job3-before-4x3-1200x900-_1787270257228.webp";
import renovJob3After from "@assets/tlc-associates-landscape-renovation-job3-after-4x3-1200x900-a_1787270257228.webp";
import tsJob1Before from "@assets/tlc-associates-tree-and-shrub-care-job1-before-4x3-1200x900-n_1787270257229.webp";
import tsJob1After from "@assets/tlc-associates-tree-and-shrub-care-job1-after-4x3-1200x900-no_1787270257229.webp";
import tsJob2Before from "@assets/tlc-associates-tree-and-shrub-care-job2-before-4x3-1200x900-n_1787270257230.webp";
import tsJob2After from "@assets/tlc-associates-tree-and-shrub-care-job2-after-4x3-1200x900-no_1787270257230.webp";
import commJob1Before from "@assets/tlc-associates-commercial-services-job1-before-4x3-1200x900-m_1787270257231.webp";
import commJob1After from "@assets/tlc-associates-commercial-services-job1-after-4x3-1200x900-me_1787270257231.webp";

import mulchCommDesktop from "@assets/mulch_commercial_desktop_1776164743860.webp";
import mulchCommMobile from "@assets/mulch_commercial_mobile_1776164743860.webp";

import skidSteerCommGradingDesktop from "@assets/commerical_a_desktop_1776168730734.webp";
import skidSteerCommGradingMobile from "@assets/commerical_a_mobile_1776168730733.webp";
import skidSteerResidentialRemovalDesktop from "@assets/residential_a_desktop_1776168730737.webp";
import skidSteerResidentialRemovalMobile from "@assets/residential_a_mobile_1776168730736.webp";
import commMunicipalParkDesktop from "@assets/commercial_c_desktop_1776168730739.webp";
import commMunicipalParkMobile from "@assets/commercial_c_mobile_1776168730738.webp";
import commLakefrontDesktop from "@assets/commercial_d_desktop_1776168730746.webp";
import commLakefrontMobile from "@assets/commercial_d_mobile_1776168730746.webp";
import scagMowerDesktop from "@assets/scag_a_desktop_1776168730740.webp";
import scagMowerMobile from "@assets/scag_a_mobile_1776168730740.webp";
import lawnStripingDesktop from "@assets/residential_b_desktop_1776168730742.webp";
import lawnStripingMobile from "@assets/residential_b_mobile_1776168730741.webp";
import hardscapingStoneWalkwayDesktop from "@assets/residential_c_desktop_1776168730743.webp";
import hardscapingStoneWalkwayMobile from "@assets/residential_c_mobile_1776168730743.webp";
import mulchDrivewayDesktop from "@assets/residential_d_desktop_1776168730745.webp";
import mulchDrivewayMobile from "@assets/residential_d_mobile_1776168730744.webp";

import heroDesktop from "@assets/Homepage_Hero_TLC_Associates_Desktop_1775950961981.webp";
import heroMobile from "@assets/Homepage_Hero_TLC_Associates_Mobile_1775950949982_600.webp";

import landscapeRenovationHeroDesktop from "@assets/tlc-associates-landscape-renovation-desktop_1776026719383.webp";
import landscapeRenovationHeroMobile from "@assets/tlc-associates-landscape-renovation-mobile_1776026719382_600.webp";

import snowplowHeroDesktop from "@assets/snowplow_hero_desktop_1776038599874.webp";
import snowplowHeroMobile from "@assets/snowplow_hero_mobile_1776038599873_600.webp";

import hardscapingHeroDesktop from "@assets/hardscaping_page_hero_desktop_1776036558824.webp";
import hardscapingHeroMobile from "@assets/hardscaping_page_hero_mobile_1776036558821_600.webp";
import treeAndShrubHeroDesktop from "@assets/tree_and_shrub_care_page_hero_desktop_1776036558829.webp";
import treeAndShrubHeroMobile from "@assets/tree_and_shrub_care_page_hero_mobile_1776036558826_600.webp";
import snowplowCommercial1200 from "@assets/snowplow_commercial_1200_1776038599870.webp";
import snowplowCommercial600 from "@assets/snowplow_commercial_600_1776038599869.webp";
import snowplowFleet1200 from "@assets/snowplow_1200_1776038599872.webp";
import snowplowFleet600 from "@assets/snowplow_600_1776038599871.webp";

import skidSteerHeroDesktop from "@assets/Skid_steering_page_hero_desktop_1776036537793.webp";
import skidSteerHeroMobile from "@assets/Skid_steering_page_hero_mobile_1776036408457_600.webp";

export interface BeforeAfterSet {
  before: { large: string; small: string };
  after: { large: string; small: string };
  alt: string;
  category: string;
}

export interface ShowcaseImage {
  src: string;
  alt: string;
  category: string;
}

export const beforeAfterSets: Record<number, BeforeAfterSet> = {
  1: {
    before: { large: img1Before1200, small: img1Before600 },
    after: { large: img1After1200, small: img1After600 },
    alt: "Tree trimming and pruning",
    category: "Tree & Shrub Care",
  },
  2: {
    before: { large: img2Before1200, small: img2Before600 },
    after: { large: img2After1200, small: img2After600 },
    alt: "Hedge trimming and shaping",
    category: "Landscape Maintenance",
  },
  3: {
    before: { large: img3Before1200, small: img3Before600 },
    after: { large: img3After1200, small: img3After600 },
    alt: "Backyard hardscaping stone border",
    category: "Stonework",
  },
  4: {
    before: { large: img4Before1200, small: img4Before600 },
    after: { large: img4After1200, small: img4After600 },
    alt: "Bed edging, mulching and cleanup",
    category: "Landscape Renovation",
  },
  5: {
    before: { large: img5Before1200, small: img5Before600 },
    after: { large: img5After1200, small: img5After600 },
    alt: "Garden bed installation",
    category: "Garden & Planting",
  },
  6: {
    before: { large: img6Before1200, small: img6Before600 },
    after: { large: img6After1200, small: img6After600 },
    alt: "Residential shrub pruning",
    category: "Landscape Maintenance",
  },
  7: {
    before: { large: img7Before1200, small: img7Before600 },
    after: { large: img7After1200, small: img7After600 },
    alt: "Overgrown backyard restoration",
    category: "Landscape Renovation",
  },
  8: {
    before: { large: img8Before1200, small: img8Before600 },
    after: { large: img8After1200, small: img8After600 },
    alt: "Front yard bed cleanup",
    category: "Landscape Maintenance",
  },
  9: {
    before: { large: img9Before1200, small: img9Before600 },
    after: { large: img9After1200, small: img9After600 },
    alt: "Commercial lot cleanup",
    category: "Commercial Services",
  },
  10: {
    before: { large: img10Before1200, small: img10Before600 },
    after: { large: img10After1200, small: img10After600 },
    alt: "Driveway edge clearing",
    category: "Landscape Renovation",
  },
  11: {
    before: { large: img11Before1200, small: img11Before600 },
    after: { large: img11After1200, small: img11After600 },
    alt: "Mulch installation",
    category: "Garden & Planting",
  },
  12: {
    before: { large: img12Before1200, small: img12Before600 },
    after: { large: img12After1200, small: img12After600 },
    alt: "Roadside clearing with fresh mulch",
    category: "Landscape Renovation",
  },
  14: {
    before: { large: img14Before1200, small: img14Before600 },
    after: { large: img14After1200, small: img14Done1200 },
    alt: "Ornamental conifer shaping",
    category: "Tree & Shrub Care",
  },
  15: {
    before: { large: img15Before1200, small: img15Before600 },
    after: { large: img15After1200, small: img15After600 },
    alt: "Roadside hedge and bed cleanup",
    category: "Garden & Planting",
  },
  27: {
    before: { large: img27Before, small: img27Before },
    after: { large: img27After, small: img27After },
    alt: "Weeding, pruning, and mulch installation",
    category: "Garden & Planting",
  },
  28: {
    before: { large: img28Before, small: img28Before },
    after: { large: img28After, small: img28After },
    alt: "Commercial municipal lot cleanup",
    category: "Commercial Services",
  },
  29: {
    before: { large: img29Before, small: img29BeforeSmall },
    after: { large: img29After, small: img29AfterSmall },
    alt: "Commercial pruning and maintenance",
    category: "Commercial Services",
  },
  32: {
    before: { large: img32Before1200, small: img32Before600 },
    after: { large: img32After1200, small: img32After600 },
    alt: "Dense roadside brush and brambles cleared back to open ground",
    category: "Landscape Maintenance",
  },
  33: {
    before: { large: img33Before1200, small: img33Before600 },
    after: { large: img33After1200, small: img33After600 },
    alt: "Overgrown brush and shrub line cleared along wooded driveway edge",
    category: "Landscape Maintenance",
  },
  34: {
    before: { large: img34Before1200, small: img34Before600 },
    after: { large: img34After1200, small: img34After600 },
    alt: "Overgrown wooded side yard cleared of brush and debris beside a red barn",
    category: "Landscape Maintenance",
  },
  35: {
    before: { large: img35Before1200, small: img35Before600 },
    after: { large: img35After1200, small: img35After600 },
    alt: "Weedy driveway island replaced with a fresh mulched garden bed and new plantings",
    category: "Garden & Planting",
  },
  36: {
    before: { large: lmJob1Before1200, small: lmJob1Before600 },
    after: { large: lmJob1After1200, small: lmJob1After600 },
    alt: "Residential mulch bed refresh around Japanese maple and driveway island",
    category: "Landscape Maintenance",
  },
  37: {
    before: { large: lmJob2Before1200, small: lmJob2Before600 },
    after: { large: lmJob2After1200, small: lmJob2After600 },
    alt: "Dense residential backyard overgrowth cleared to open ground with skid steer",
    category: "Landscape Maintenance",
  },
  38: {
    before: { large: renovJob2FranklinBefore, small: renovJob2FranklinBefore },
    after: { large: renovJob2FranklinAfter, small: renovJob2FranklinAfter },
    alt: "Fenced backyard gravel delivered and spread into a clean, level surface",
    category: "Landscape Renovation",
  },
  39: {
    before: { large: renovJob3Before, small: renovJob3Before },
    after: { large: renovJob3After, small: renovJob3After },
    alt: "Densely wooded residential backyard cleared to open ground with skid steer",
    category: "Landscape Renovation",
  },
  40: {
    before: { large: tsJob1Before, small: tsJob1Before },
    after: { large: tsJob1After, small: tsJob1After },
    alt: "Overgrown colonial front yard shrubs and beds pruned and cleaned up",
    category: "Tree & Shrub Care",
  },
  41: {
    before: { large: tsJob2Before, small: tsJob2Before },
    after: { large: tsJob2After, small: tsJob2After },
    alt: "Tall roadside boxwood hedge trimmed to a crisp, even profile",
    category: "Tree & Shrub Care",
  },
  42: {
    before: { large: commJob1Before, small: commJob1Before },
    after: { large: commJob1After, small: commJob1After },
    alt: "Commercial roadside embankment brush cleared to clean maintained lawn edge",
    category: "Commercial Services",
  },
};

export const showcaseImages: Record<number, ShowcaseImage | ShowcaseImage[]> = {
  13: [
    { src: img13a, alt: "Commercial townhouse community landscaping - angle 1", category: "Commercial Services" },
    { src: img13b, alt: "Commercial townhouse community landscaping - angle 2", category: "Commercial Services" },
    { src: img13c, alt: "Commercial townhouse community landscaping - angle 3", category: "Commercial Services" },
    { src: img13d, alt: "Commercial townhouse community landscaping - angle 4", category: "Commercial Services" },
  ],
  16: [
    { src: img16Path1200, alt: "Skid steer land clearing - mulch pathway", category: "Skid Steer Services" },
    { src: img16Clear1200, alt: "Skid steer heavy equipment clearing", category: "Skid Steer Services" },
  ],
  17: { src: img17After1200, alt: "Skid steer woodland clearing action shot", category: "Skid Steer Services" },
  18: { src: img18, alt: "Residential foundation plantings", category: "Tree & Shrub Care" },
  19: { src: img19, alt: "Residential landscape maintenance with mulch beds", category: "Landscape Maintenance" },
  20: { src: img20Desktop, alt: "Tree ring mulch bed planting", category: "Garden & Planting" },
  21: { src: img21 || img18, alt: "Lakefront property maintenance", category: "Landscape Maintenance" },
  22: { src: img22 || img18, alt: "Fall leaf cleanup with TLC trucks", category: "Landscape Maintenance" },
  23: { src: img23 || img18, alt: "Precision lawn mowing concentric circles pattern", category: "Landscape Maintenance" },
  24: { src: img24 || img18, alt: "Lawn care with flower bed maintenance", category: "Landscape Maintenance" },
  25: { src: img25 || img18, alt: "Commercial lawn mowing equipment in action", category: "Landscape Maintenance" },
  26: { src: img26 || img18, alt: "Residential lawn mowing striping", category: "Landscape Maintenance" },
  30: { src: mulchCommDesktop, alt: "Commercial retail storefront mulch and planting installation", category: "Commercial Services" },
  31: { src: snowplowCommercial1200, alt: "Commercial snow plowing with plow truck", category: "Snow Plowing" },
};

export const heroMobileImages: Record<string, string> = {
  "/": heroMobile,
  "/landscape-renovation": landscapeRenovationHeroMobile,
  "/snow-plowing": snowplowHeroMobile,
  "/stonework": hardscapingHeroMobile,
  "/tree-and-shrub-care": treeAndShrubHeroMobile,
  "/commercial-services/skid-steer-services": skidSteerHeroMobile,
};

export const heroImages: Record<string, string> = {
  "/": heroDesktop,
  "/lawn-care": img23 || img18,
  "/garden-and-planting": img35After1200,
  "/landscape-renovation": landscapeRenovationHeroDesktop,
  "/tree-and-shrub-care": treeAndShrubHeroDesktop,
  "/stonework": hardscapingHeroDesktop,
  "/commercial-services": img29After,
  "/commercial-services/skid-steer-services": skidSteerHeroDesktop,
  "/snow-plowing": snowplowHeroDesktop,
  "/service-areas": img21 || img18,
  "/contact": img24 || img18,
};

export const heroDesktopToMobile: Record<string, string> = {
  [heroDesktop]: heroMobile,
  [img23]: maintenanceHeroMobile,
  [img35After1200]: img35After600,
  [landscapeRenovationHeroDesktop]: landscapeRenovationHeroMobile,
  [treeAndShrubHeroDesktop]: treeAndShrubHeroMobile,
  [hardscapingHeroDesktop]: hardscapingHeroMobile,
  [img29After]: commercialHeroMobile,
  [skidSteerHeroDesktop]: skidSteerHeroMobile,
  [snowplowHeroDesktop]: snowplowHeroMobile,
  [img21]: serviceAreaHeroMobile,
  [img24]: contactHeroMobile,
};

export const heroMobileDimensions: Record<string, { width: number; height: number }> = {
  [heroMobile]: { width: 600, height: 1067 },
  [maintenanceHeroMobile]: { width: 600, height: 450 },
  [img35After600]: { width: 600, height: 450 },
  [landscapeRenovationHeroMobile]: { width: 600, height: 1067 },
  [treeAndShrubHeroMobile]: { width: 600, height: 1066 },
  [hardscapingHeroMobile]: { width: 600, height: 1067 },
  [commercialHeroMobile]: { width: 600, height: 450 },
  [skidSteerHeroMobile]: { width: 600, height: 1067 },
  [snowplowHeroMobile]: { width: 600, height: 1067 },
  [serviceAreaHeroMobile]: { width: 600, height: 750 },
  [contactHeroMobile]: { width: 600, height: 450 },
};

export const snowplowImages = {
  commercial: { large: snowplowCommercial1200, small: snowplowCommercial600 },
  fleet: { large: snowplowFleet1200, small: snowplowFleet600 },
};

export const commercialShowcaseImages = {
  mulch: { desktop: mulchCommDesktop, mobile: mulchCommMobile },
  plowing: { desktop: snowplowCommercial1200, mobile: snowplowCommercial600 },
  municipalPark: { desktop: commMunicipalParkDesktop, mobile: commMunicipalParkMobile },
};

export const skidSteerShowcaseImages = {
  commGrading: { desktop: skidSteerCommGradingDesktop, mobile: skidSteerCommGradingMobile },
  residentialRemoval: { desktop: skidSteerResidentialRemovalDesktop, mobile: skidSteerResidentialRemovalMobile },
};

export const maintenanceShowcaseImages = {
  lakefront: { desktop: commLakefrontDesktop, mobile: commLakefrontMobile },
  scagMower: { desktop: scagMowerDesktop, mobile: scagMowerMobile },
  lawnStriping: { desktop: lawnStripingDesktop, mobile: lawnStripingMobile },
};

export const hardscapingShowcaseImages = {
  stoneWalkway: { desktop: hardscapingStoneWalkwayDesktop, mobile: hardscapingStoneWalkwayMobile },
};

export const gardenShowcaseImages = {
  mulchDriveway: { desktop: mulchDrivewayDesktop, mobile: mulchDrivewayMobile },
};

const _webpModules = import.meta.glob("@assets/*.webp", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

const _avifModules = import.meta.glob("@assets/*.avif", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

export const webpToAvif: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const [webpPath, webpUrl] of Object.entries(_webpModules)) {
    const avifPath = webpPath.replace(/\.webp$/i, ".avif");
    const avifUrl = _avifModules[avifPath];
    if (avifUrl) {
      map[webpUrl] = avifUrl;
    }
  }
  return map;
})();

// 600px-wide, compressed WebP/AVIF copies used for mobile and gallery images.
const _gallery600Modules = import.meta.glob("@assets/g600/*.webp", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

const _gallery600AvifModules = import.meta.glob("@assets/g600/*.avif", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

export const webpToGallery600: Record<string, string> = (() => {
  const byName: Record<string, string> = {};
  for (const [path, url] of Object.entries(_gallery600Modules)) {
    byName[path.split("/").pop()!] = url;
  }
  const map: Record<string, string> = {};
  for (const [webpPath, webpUrl] of Object.entries(_webpModules)) {
    const g600Url = byName[webpPath.split("/").pop()!];
    if (g600Url) {
      map[webpUrl] = g600Url;
    }
  }
  return map;
})();

export const gallery600WebpToAvif: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const [webpPath, webpUrl] of Object.entries(_gallery600Modules)) {
    const avifPath = webpPath.replace(/\.webp$/i, ".avif");
    const avifUrl = _gallery600AvifModules[avifPath];
    if (avifUrl) {
      map[webpUrl] = avifUrl;
    }
  }
  return map;
})();
